import React, { PureComponent, Fragment } from "react";

import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

import {
  StandardTooltip,
  MAIN_COLORS,
  Error,
  selectFormat,
} from "./../Utils/Utils.js";

class LeeSubscriptionsPieChart extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  generateDataForExport = () => {
    const data = this.props.data.data;
    let formattedData = [];

    Object.keys(data).map((i) =>
      formattedData.push({
        Network: data[i].name,
        Value: selectFormat("number", data[i].followers, "0,0"),
        Percentage: selectFormat("percentage", data[i].value / 100),
        // numeral(data.click_rate_30).divide(100).format('%')
      })
    );

    return formattedData;
  };

  getExportData = () => ({
    data: this.generateDataForExport(),
    opts: {
      type: "other",
    },
  });

  renderCell = (entry, index) => (
    <Cell key={index} fill={MAIN_COLORS[index + (8 % MAIN_COLORS.length)]} />
  );

  renderPercentage(data) {
    const total = data.reduce((s, e) => s + e.value, 0);
    const sorted = data.sort((a, b) => a.value - b.value);

    sorted.reverse();

    return sorted.map((e, key) => {
      if (((e.value * 100) / total).toFixed(2) > 0) {
        // prevent 0%
        return (
          <div className="mb-1 text-left" key={e.name}>
            <span
              className="pr-1"
              style={{ color: MAIN_COLORS[key + (8 % MAIN_COLORS.length)] }}
            >
              {((e.value * 100) / total).toFixed(2)}%
            </span>
            <span>{e.name}</span>
          </div>
        );
      } else {
        return null;
      }
    });
  }

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <div className="col-12">
        <div className="row">
          <div className="pt-3 col-12">
            <ResponsiveContainer height={350}>
              <PieChart>
                <Pie
                  data={data.data}
                  dataKey="value"
                  innerRadius={75}
                  outerRadius={130}
                  isAnimationActive={false}
                  label={({
                    cx,
                    cy,
                    midAngle,
                    innerRadius,
                    outerRadius,
                    value,
                    index,
                  }) => {
                    const RADIAN = Math.PI / 180;
                    const radius =
                      25 + innerRadius + (outerRadius - innerRadius);
                    const x = cx + radius * Math.cos(-midAngle * RADIAN);
                    const y = cy + radius * Math.sin(-midAngle * RADIAN);

                    return (
                      <text
                        x={x}
                        y={y}
                        fill={MAIN_COLORS[index + (8 % MAIN_COLORS.length)]}
                        textAnchor={x > cx ? "start" : "end"}
                        dominantBaseline="central"
                      >
                        {data.data[index].name} ({value.toFixed(2)}%)
                      </text>
                    );
                  }}
                >
                  {data.data?.map(this.renderCell)}
                </Pie>

                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(data.graph);

                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              <header className="standard-tooltip__header">
                                <span className="standard-tooltip__key-header">
                                  Followers/Subscribers Breakdown
                                </span>
                              </header>

                              <main className="standard-tooltip__main">
                                {Object.keys(payload)
                                  .sort(
                                    (a, b) =>
                                      payload[b].value - payload[a].value
                                  )
                                  .filter((key) => payload[key].value > 0)
                                  .map((key) => (
                                    <Fragment key={key}>
                                      <div className="standard-tooltip__item">
                                        <span
                                          className="standard-tooltip__key"
                                          style={{
                                            color: payload[key].payload.fill,
                                          }}
                                        >
                                          <span
                                            className="standard-tooltip__icon"
                                            style={{
                                              background:
                                                payload[key].payload.fill,
                                            }}
                                          />
                                          {payload[key].payload.name}
                                        </span>
                                        <span className="standard-tooltip__value">
                                          {selectFormat(
                                            "percent",
                                            payload[key].payload.value / 100,
                                            "0.00%"
                                          )}{" "}
                                          (
                                          {selectFormat(
                                            "number",
                                            payload[key].payload.subscriptions
                                          )}
                                          )
                                        </span>
                                      </div>
                                    </Fragment>
                                  ))}
                              </main>
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default LeeSubscriptionsPieChart;
